import { getCompleteFormStore } from '../actions/FormValidationAction'

export const isEngineView = () =>
  window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN === 'kxEngineBrokerToken'

const isPscChildShipmentId = (shipId) => (shipId || '').includes('--')

const getCreateEntrySummaryFn = () =>
  getCompleteFormStore()?.DropDownValues?.functionsPassed_i?.createEntrySummary

export const clearEnginePscNavigation = () => {
  window.GLOBAL_HAS_REDIRECTED_USING_PSCCHAIN = false
}

/** Load PSC child entry summary in engine (optional -- suffix check). */
export const reloadEnginePscChildForm = (shipId, { requirePscChild = true } = {}) => {
  if (!isEngineView() || !shipId) return false
  if (requirePscChild && !isPscChildShipmentId(shipId)) return false
  const createEntrySummary = getCreateEntrySummaryFn()
  if (!createEntrySummary) return false
  createEntrySummary({ shipId, isChainMode: true }, 'pscMode')
  return true
}

/** After startPSC: select child, set chain flags, load child form. */
export const navigateEngineToPscChild = (shipId, { getClickedShipId } = {}) => {
  if (!isEngineView() || !shipId) return false
  window.pscShipmentId = shipId
  window.GLOBAL_USER_SELECTED_SHIPMENT_ID = shipId
  window.GLOBAL_HAS_REDIRECTED_USING_PSCCHAIN = true
  if (typeof getClickedShipId === 'function') {
    getClickedShipId(shipId)
  }
  return reloadEnginePscChildForm(shipId, { requirePscChild: false })
}

/** After update response: clear flags, refresh broker job, reload child form. */
export const refreshEnginePscChildAfterUpdate = (shipId, { setCurrentBrokerJob } = {}) => {
  if (!isEngineView()) return false
  clearEnginePscNavigation()
  if (isPscChildShipmentId(shipId)) {
    window.pscShipmentId = shipId
  }
  if (typeof setCurrentBrokerJob === 'function') {
    setCurrentBrokerJob(shipId)
  }
  return reloadEnginePscChildForm(shipId, { requirePscChild: false })
}
